import { GET_ALLOWANCES } from '../mutation-types'

const state = { all: [] }

const mutations = {
  [GET_ALLOWANCES] (state, allowances) {
    state.all = allowances
  }
}

export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/allowances.js